import { differenceInCalendarDays, format, isValid, parseISO } from 'date-fns';

/**
 * Compact last-activity label for consultant ops table (e.g. "3d ago").
 * @param {string|Date|null|undefined} value
 * @returns {string}
 */
export const formatLastActivity = (value) => {
  if (!value) return 'Never';
  const date = value instanceof Date ? value : parseISO(String(value));
  if (!isValid(date)) return 'Never';
  const days = differenceInCalendarDays(new Date(), date);
  if (days <= 0) return 'Today';
  if (days === 1) return '1d ago';
  return `${days}d ago`;
};

/**
 * Absolute date for title/tooltip next to relative last-activity.
 * @param {string|Date|null|undefined} value
 * @returns {string}
 */
export const formatLastActivityAbsolute = (value) => {
  if (!value) return '';
  const date = value instanceof Date ? value : parseISO(String(value));
  if (!isValid(date)) return '';
  return format(date, 'do MMM yyyy');
};
